import { createContext } from 'react';

const postContext = createContext();

export default postContext;